import React, { useEffect } from "react";
import classnames from "classnames/bind";
import { Link } from "react-router-dom";
import { connect } from "react-redux";

import { setMeta } from "src/redux/meta/actions";

import css from "./index.scss";
import SubContent from "./components/SubContent";
import HeroSwiper from "./components/HeroSwiper";

const cx = classnames.bind(css);
const moduleName = "Main";

const FEATURES = [
  { num: "Ⅰ", en: "Nature", title: "뛰어난 자연경관", desc: "탁 트인 산 풍경과 맑은 계곡이 함께하는 곳" },
  { num: "Ⅱ", en: "River",  title: "바로 옆 강",      desc: "천렵과 낚시를 즐길 수 있는 청정 자연 속" },
  { num: "Ⅲ", en: "Host",   title: "친절한 주인장",   desc: "가족 같은 따뜻한 환대로 맞이합니다" },
];

const CTA_ITEMS = [
  { to: "/reservation", en: "Reservation", label: "예약 안내", sub: "온라인 예약 및 문의" },
  { href: "tel:01047386659", en: "Call",   label: "전화 예약", sub: "010 · 4738 · 6659" },
  { to: "/direction",   en: "Direction",   label: "오시는 길", sub: "강원도 영월군 무릉도원면" },
];

const Main = ({ setMeta }) => {
  useEffect(() => {
    const password = window.localStorage.getItem("passwordForSignIn");
    if (password) {
      setMeta({ isLogined: true });
    }
  }, []);

  return (
    <div className={cx(moduleName)}>
      <HeroSwiper />

      {/* Feature strip */}
      <section className={cx(`${moduleName}-features`)}>
        {FEATURES.map((f, i) => (
          <div key={i} className={cx(`${moduleName}-feature`)} data-aos="fade-up" data-aos-delay={i * 120}>
            <span className={cx(`${moduleName}-feature-num`)}>{f.num}</span>
            <span className={cx(`${moduleName}-feature-en`)}>{f.en}</span>
            <div className={cx(`${moduleName}-feature-line`)} />
            <h4 className={cx(`${moduleName}-feature-title`)}>{f.title}</h4>
            <p className={cx(`${moduleName}-feature-desc`)}>{f.desc}</p>
          </div>
        ))}
      </section>

      {/* Intro text section */}
      <section className={cx(`${moduleName}-intro`)}>
        <div className={cx(`${moduleName}-intro-text`)} data-aos="fade-up">
          <p className={cx(`${moduleName}-intro-label`)}>Our Story</p>
          <h2 className={cx(`${moduleName}-intro-title`)}>
            아름다운 추억과<br />즐거운 행복을
          </h2>
          <p className={cx(`${moduleName}-intro-desc`)}>
            그림 같은 자연경관과 함께, 가족·친구·연인과<br />
            잊지 못할 추억을 만들어 가세요.
          </p>
          <Link to="/surrounding" className={cx(`${moduleName}-intro-btn`)}>
            주변전경 보기
          </Link>
        </div>
      </section>

      <SubContent />

      {/* CTA bottom */}
      <section className={cx(`${moduleName}-cta`)}>
        {CTA_ITEMS.map((item, i) => {
          const inner = (
            <React.Fragment>
              <span className={cx(`${moduleName}-cta-en`)}>{item.en}</span>
              <span className={cx(`${moduleName}-cta-label`)}>{item.label}</span>
              <span className={cx(`${moduleName}-cta-sub`)}>{item.sub}</span>
              <span className={cx(`${moduleName}-cta-arrow`)} />
            </React.Fragment>
          );
          return item.to ? (
            <Link key={i} to={item.to} className={cx(`${moduleName}-cta-item`)}>
              {inner}
            </Link>
          ) : (
            <a key={i} href={item.href} className={cx(`${moduleName}-cta-item`)}>
              {inner}
            </a>
          );
        })}
      </section>
    </div>
  );
};

export default connect(
  ({ meta }) => ({ meta }),
  { setMeta }
)(Main);



// WEBPACK FOOTER //
// ./src/App/pages/Home/pages/Main/index.js